import { useCallback, useEffect, useRef, useState } from "react";

const hasRenderedOverflow = (node) => {
  if (!node) return false;
  return node.scrollHeight > node.clientHeight + 1
    || node.scrollWidth > node.clientWidth + 1;
};

const useOverflowToggle = (dependencyKey = "") => {
  const contentRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);

  const measureOverflow = useCallback(() => {
    setHasOverflow(hasRenderedOverflow(contentRef.current));
  }, []);

  useEffect(() => {
    setExpanded(false);
  }, [dependencyKey]);

  useEffect(() => {
    measureOverflow();
    const node = contentRef.current;
    if (!node) return undefined;

    if (typeof ResizeObserver === "function") {
      const observer = new ResizeObserver(measureOverflow);
      observer.observe(node);
      return () => observer.disconnect();
    }

    if (typeof window !== "undefined") {
      window.addEventListener("resize", measureOverflow);
      return () => window.removeEventListener("resize", measureOverflow);
    }

    return undefined;
  }, [measureOverflow, expanded, dependencyKey]);

  return {
    contentRef,
    expanded,
    hasOverflow,
    toggleExpanded: () => setExpanded((value) => !value),
  };
};

export default useOverflowToggle;
